var _style, _g, _g2, _g3, _path, _rect, _g4, _path2, _g5, _linearGradient, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAflacIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#02A6E3;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FEFFFF;}\n\t.st3{fill:#FBFBFD;}\n\t.st4{fill:#F8FAFC;}\n\t.st5{fill:#EEF1F7;}\n\t.st6{fill:#E3E8F2;}\n\t.st7{fill:#E2E8F2;}\n\t.st8{fill:#D2DBEB;}\n\t.st9{fill:#F4F6FA;}\n\t.st10{fill:#FAFBFD;}\n\t.st11{fill:#F9FAFC;}\n\t.st12{fill:#EDF0F7;}\n\t.st13{fill:#E0E7F1;}\n\t.st14{fill:#DFE5F1;}\n\t.st15{fill:#DEE5F1;}\n\t.st16{fill:#E7ECF4;}\n\t.st17{fill:#D7DFEE;}\n\t.st18{fill:#DCE3EF;}\n\t.st19{fill:#CAD4E7;}\n\t.st20{fill:#E6EAF4;}\n\t.st21{fill:#C8D3E7;}\n\t.st22{fill:#B5C5DE;}\n\t.st23{fill:#C2CFE4;}\n\t.st24{fill:#B1C1DC;}\n\t.st25{fill:#A0B4D4;}\n\t.st26{fill:#8FA7CC;}\n\t.st27{fill:#EBEEF6;}\n\t.st28{fill:#F1F4F9;}\n\t.st29{fill:#DBE2EF;}\n\t.st30{fill:#E3E9F3;}\n\t.st31{fill:#DAE1EE;}\n\t.st32{fill:#D9E1EE;}\n\t.st33{fill:#E1E7F2;}\n\t.st34{fill:#D5DDEC;}\n\t.st35{fill:#CED8E9;}\n\t.st36{fill:#C0CDE3;}\n\t.st37{fill:#C9D4E7;}\n\t.st38{fill:#BAC8E0;}\n\t.st39{fill:#A8BAD8;}\n\t.st40{fill:#88A3C9;}\n\t.st41{fill:#A3B6D5;}\n\t.st42{fill:#86A1C7;}\n\t.st43{fill:#FDFDFE;}\n\t.st44{fill:#F7F8FC;}\n\t.st45{fill:#F1F3F9;}\n\t.st46{fill:#FBFCFD;}\n\t.st47{fill:#F0F3F9;}\n\t.st48{fill:#D8DFEE;}\n\t.st49{fill:#C5D1E5;}\n\t.st50{fill:#CDD8E9;}\n\t.st51{fill:#BDCBE2;}\n\t.st52{fill:#A5B8D6;}\n\t.st53{fill:#89A3C9;}\n\t.st54{fill:#E6EBF4;}\n\t.st55{fill:#EFF3F9;}\n\t.st56{fill:#D5DEED;}\n\t.st57{fill:#E9EDF5;}\n\t.st58{fill:#AEBFDB;}\n\t.st59{fill:#90A8CC;}\n\t.st60{fill:#9DB1D2;}\n\t.st61{fill:#C4D0E5;}\n\t.st62{fill:#CFD8E9;}\n\t.st63{fill:url(#a);}\n\t.st64{fill:#0D4D84;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(284.39 710.72)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m214.16-384.99h1.26c1.4 0 2.66-0.42 2.66-1.68 0-0.98-0.7-1.68-2.38-1.68-0.7 0-1.12 0.14-1.4 0.14v3.22h-0.14zm-0.14 6.45h-2.66v-11.36c0.98-0.14 2.52-0.42 4.35-0.42 2.1 0 3.08 0.42 3.93 0.84 0.56 0.42 1.12 1.4 1.12 2.38 0 1.26-0.98 2.24-2.38 2.66v0.14c1.12 0.42 1.68 1.26 2.1 2.8 0.42 1.68 0.56 2.38 0.84 2.8h-2.8c-0.28-0.42-0.56-1.4-0.84-2.66s-0.84-1.82-2.38-1.82h-1.26l-0.02 4.64zm1.82-15c-5.05 0-8.69 4.07-8.69 9.11s3.79 9.11 8.83 9.11 8.69-4.07 8.69-9.11-3.64-9.11-8.83-9.11zm0.14-2.39c6.59 0 11.64 5.05 11.64 11.36 0 6.45-5.05 11.5-11.64 11.5s-11.78-5.05-11.78-11.5c0-6.31 5.19-11.36 11.78-11.36z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(203.13 716.81)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m-143.25-424.04h43.47l15.98 40.24h29.3l-62.81-150.59h-22.29l-63.52 150.59h26.64s26.64-65.9 27.2-67.02c0.56-1.26 1.12-2.52 1.68-4.07 0.56-1.54 1.4-3.51 2.24-5.89l4.35-10.38c1.4-3.37 2.52-6.17 3.37-8.41 0.84-2.38 1.82-4.49 2.66-6.73 0.84-2.1 1.68-4.35 2.38-6.59s1.68-4.91 2.66-8.13h0.7c0.98 3.22 1.96 5.89 2.66 8.13s1.4 4.35 2.1 6.45c0.7 1.96 1.4 4.21 2.38 6.59 0.84 2.38 1.96 5.19 3.37 8.69l4.35 10.8c0.84 2.1 1.68 3.93 2.24 5.33s1.12 2.8 1.54 3.93c0.42 1.26 0.98 2.38 1.54 3.65 0.56 1.26 1.96 4.07 1.96 4.07h-45.43l9.28 19.34z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(231 724.64)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m-20.71-474.03h-26.5c0 0.42 0.14 82.44 0.14 82.44h-25.94v-82.45h-20.05v-18.93h20.05v-11.08c0-6.73 0.98-12.9 3.08-18.37 1.96-5.47 4.91-10.24 8.83-14.16 3.79-3.93 8.55-7.01 14.02-9.39s11.64-3.79 18.37-4.21c3.37-0.28 6.17-0.28 8.55 0s5.19 0.84 8.41 1.54l-4.07 18.79c-1.68-0.28-3.22-0.42-4.63-0.56-1.4-0.14-3.22 0-5.47 0.14-8.13 0.7-13.88 3.22-17.11 7.43-1.68 2.24-2.8 4.91-3.37 7.85-0.56 2.94-0.84 7.71-0.84 14.16v7.85h26.92v18.93l-0.39 0.02z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m380.92 318.13c-1.54-0.42-2.94-1.26-3.93-2.24-0.56-0.7-1.12-1.54-1.4-2.24-0.42-0.7-0.7-1.82-0.84-3.08-0.28-1.26-0.42-2.94-0.42-4.91-0.14-1.96-0.14-4.49-0.14-7.71v-29.86c0-12.9-2.24-22.15-6.73-27.62-3.37-3.79-7.57-6.73-13.04-8.69-5.33-1.96-11.5-3.08-18.37-3.08-12.48 0-25.66 3.65-39.26 10.8v19.49c6.73-3.51 12.48-6.03 17.11-7.57s9.25-2.52 14.16-2.8c6.31-0.42 11.36 0.7 15.14 3.51s5.61 6.73 5.61 11.92v5.05c-9.53 0.7-17.11 1.82-24.68 3.37s-13.32 3.37-17.11 5.33c-5.47 2.8-9.67 6.73-12.9 11.64s-4.77 10.24-4.77 15.98c0 9.53 2.52 16.83 7.71 21.87 2.52 2.66 5.89 4.91 9.81 6.45 3.93 1.54 7.99 2.38 12.06 2.38 3.22 0 6.03-0.14 8.41-0.56 2.52-0.42 4.91-0.98 7.43-1.96 2.52-0.84 5.05-2.24 7.85-3.79 2.66-1.68 5.89-3.79 9.53-6.59 1.82 6.87 7.15 10.94 15.98 12.2 2.52 0.28 4.91 0.42 7.29 0.28 2.24-0.14 5.33-0.56 8.97-1.26l3.37-15.98c-3.05 0.23-5.29 0.09-6.84-0.33zm-32.39-26.22v19.49c-7.99 4.77-14.44 7.29-19.21 7.29-4.91 0-8.83-1.26-11.78-3.93-2.8-2.66-4.21-6.17-3.79-10.52 0.28-6.03 3.22-10.66 8.69-13.74 5.47-3.22 13.6-5.33 26.08-7.01v8.42z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 232.72,
    y: 176.1,
    width: 25.94,
    height: 156.9
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(278.19 723.3)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m186.85-465.46c-4.35-2.8-8.13-4.77-11.36-5.89-3.22-1.12-6.73-1.54-10.66-1.54s-7.57 0.7-10.8 2.24c-3.37 1.54-6.17 3.65-8.55 6.17-2.38 2.66-4.35 5.75-5.61 9.53-1.4 3.65-2.1 7.71-2.1 12.06 0 4.77 0.7 9.25 2.1 13.32s3.37 7.57 5.89 10.52c2.52 2.94 5.47 5.19 8.97 6.87 3.51 1.68 7.29 2.52 11.36 2.52 2.24 0 4.35-0.14 6.17-0.28 1.82-0.28 3.79-0.56 5.47-1.12 1.82-0.56 3.65-1.26 5.47-2.1s4.07-2.1 6.45-3.37l8.55 17.67c-10.52 7.99-22.71 11.92-36.31 11.92-7.71 0-14.58-1.26-20.89-3.93-6.31-2.66-11.64-6.31-15.98-11.22-4.49-4.77-7.85-10.66-10.24-17.39-2.38-6.73-3.65-14.3-3.65-22.57 0-6.87 1.4-13.6 4.21-20.05 2.8-6.45 6.59-12.06 11.36-16.83s10.24-8.69 16.54-11.5c6.31-2.8 12.9-4.35 19.77-4.35 7.29 0 13.46 0.84 18.79 2.38s10.52 4.21 15.84 7.99l-10.79 18.95z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m237.91 219c-1.26 6.87-2.94 15.98-8.69 22.15-5.47 6.03-12.48 10.8-20.19 15.56-2.66 1.68-3.65 3.37-3.65 5.89 0 1.82 0.84 3.37 2.24 3.37 1.82 0 2.94-0.98 5.61-0.98 3.37 0 7.43 2.66 9.67 3.93-2.66 1.96-7.71 4.63-7.71 9.11 0 3.37 3.79 7.71 13.88 7.71 9.39 0 21.73-10.66 28.04-15.56 3.23-10.37-2.52-31.27-19.2-51.18"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "scale(.23801 -.23801)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m1033-1384c-7.01-18.51 1.96-26.36 17.39-26.36 31.83 73.61 52.02 177.51 57.91 244.53-9.95 1.12-19.63 2.24-26.64 3.08 0-93.66-22.16-156.61-48.66-221.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m1050.4-1410.3h69.4c24.82 74.03 27.34 225.6 27.34 240.46-8.83 0.56-24.12 2.38-38.84 4.07-6.02-67.02-26.07-171.06-57.9-244.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m1119.8-1410.3h9.11c22.57 69.12 26.64 224.62 26.64 238.22-5.05 0.7-8.13 2.24-8.41 2.24 0-14.86-2.52-166.43-27.34-240.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m1128.9-1410.3h3.93c21.59 67.16 26.36 224.48 26.5 237.66-1.26 0.14-2.66 0.28-3.79 0.56-0.14-13.6-4.07-169.1-26.64-238.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m1132.8-1410.3h0.28c21.59 67.02 26.36 224.48 26.5 237.66h-0.42c0-13.18-4.76-170.5-26.36-237.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m1133.1-1410.3h0.84c21.45 66.6 26.36 224.48 26.64 237.52-0.28 0-0.56 0.14-0.84 0.14-0.14-13.18-5.04-170.78-26.64-237.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m1133.9-1410.3h46.41c10.52 44.17 23.98 224.9 24.96 234.15-1.82 0.28-27.34 1.26-44.73 3.37-0.14-13.04-5.18-171.06-26.64-237.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m1180.3-1410.3c10.52 44.17 23.98 224.9 24.96 234.15 1.68-0.28 3.93-0.42 6.73-0.7-0.14-25.38-10.24-182.27-19.49-233.45h-12.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m1192.4-1410.3h14.16c4.07 29.3 7.99 77.12 10.66 122.82-3.93 0.14-7.85 1.96-11.5 3.65-3.78-48.79-8.55-100.81-13.32-126.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m1205.7-1283.8c3.65-1.82 7.71-3.51 11.5-3.65 2.66 45.71 4.35 89.31 3.93 109.92-3.37 0.28-6.45 0.56-9.25 0.84-0.01-12.75-2.53-58.32-6.18-107.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m1206.6-1410.3c10.52 0 17.39 2.52 22.01 6.45 5.19 33.51 7.57 73.33 8.83 112.87-5.33 1.12-11.92 3.08-20.19 3.36-2.65-45.71-6.58-93.52-10.65-122.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m1217.2-1287.6c8.13-0.28 14.86-2.24 20.19-3.36 0.7 19.77 1.12 39.54 1.4 58.33-5.61 4.35-11.92 8.83-18.51 9.25-0.56-19.07-1.68-41.36-3.08-64.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1220.4-1223.2c6.59-0.42 12.76-4.91 18.51-9.25 0.42 18.93 0.7 36.88 1.12 53.14-6.31 0.7-12.9 1.26-18.79 1.82 0.15-10.52-0.14-26.5-0.84-45.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m1228.6-1403.8c4.49 4.07 6.73 9.67 7.71 15.84 6.17 37.72 10.38 67.02 13.6 98.01-2.94-2.66-7.01-2.24-12.34-1.12-1.54-39.4-3.93-79.22-8.97-112.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m1237.4-1291c2.66-0.56 5.05-0.98 7.15-0.98 0.98 17.39 1.68 35.05 2.38 53.42-2.52 1.54-5.19 3.65-7.99 5.89-0.42-18.79-0.84-38.42-1.54-58.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m1238.8-1232.5c2.8-2.24 5.47-4.35 7.99-5.89 0.7 18.37 1.4 37.58 2.24 57.91-2.94 0.42-6.03 0.7-9.25 1.12-0.28-16.41-0.56-34.36-0.98-53.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "m1244.6-1291.8c2.1 0.14 3.79 0.7 5.33 1.96 1.54 15.56 2.94 31.41 4.21 49.07-2.24-0.14-4.49 0.84-7.01 2.38-0.85-18.36-1.55-36.03-2.53-53.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "m1246.9-1238.4c2.52-1.54 4.91-2.52 7.01-2.38 1.26 17.67 2.24 36.88 3.37 59.03-2.52 0.42-5.33 0.84-8.13 1.26-0.84-20.34-1.55-39.55-2.25-57.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m1081.6-1162.8c17.39-1.82 50.62-6.03 65.34-7.01 0 6.73 0 12.34-0.14 17.25-15.28-0.7-46.83-2.24-65.34 3.51 0.14-4.22 0.14-8.28 0.14-13.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m1081.5-1149.2c18.51-5.75 49.91-4.21 65.34-3.51-0.14 4.91-0.42 9.11-0.84 13.04-15.84-2.52-45.71-4.91-65.48 4.77 0.7-5.75 0.98-10.09 0.98-14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m1080.6-1134.9c-1.12 11.5-2.52 14.44-4.35 24.68 10.94-9.25 23.13-12.2 34.63-12.48 2.1-9.11 2.94-9.81 3.93-19.21-12.05 0.42-24.39 2.24-34.21 7.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m1114.7-1141.8c11.92-0.28 23.42 0.98 31.27 2.24-0.42 3.51-0.84 6.87-1.54 10.38-8.13-1.54-19.49-3.36-31.27-2.8 0.69-2.67 1.11-5.19 1.54-9.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m1113.3-1132.1c11.78-0.42 23.13 1.26 31.27 2.8-0.7 3.37-1.54 7.01-2.66 10.94-8.41-1.96-19.35-4.49-30.99-4.21 0.98-4.63 1.68-7.15 2.38-9.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m1147.1-1169.8c0.42 0 3.51-1.54 8.41-2.24 0.28 5.61 0.56 11.08 0.7 16.4-4.91 0.42-8.55 2.52-9.39 2.38 0.14-4.76 0.28-10.09 0.28-16.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "m1146.8-1153.3c0.84 0.14 4.49-2.1 9.39-2.38 0.28 5.19 0.42 10.24 0.42 15.14-4.77-0.56-8.69 0.28-10.52-0.14 0.43-3.92 0.71-7.99 0.71-12.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m1146.1-1140.8c1.82 0.42 5.75-0.42 10.52 0.14 0 4.77-0.14 9.39-0.42 13.88-4.63-1.4-8.83-2.38-11.64-3.08 0.7-3.65 1.26-7.15 1.54-10.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "m1144.6-1129.8c2.8 0.7 7.01 1.68 11.64 3.08-0.28 4.35-0.98 8.55-1.82 12.48-4.49-1.82-9.25-3.36-12.48-4.07 1.12-4.2 1.96-7.85 2.66-11.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m1155.5-1172c0.84-0.14 1.82-0.28 2.8-0.42 0.28 5.47 0.7 10.94 1.12 16.26-0.98 0-2.1 0.42-3.08 0.42-0.28-5.19-0.56-10.66-0.84-16.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "m1156.2-1155.8c0.98 0 2.1-0.42 3.08-0.42 0.42 5.47 0.7 10.8 0.84 15.98-1.12-0.28-2.38-0.28-3.51-0.42 0.01-4.76-0.13-9.81-0.41-15.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m1156.8-1140.6c1.12 0.28 2.38 0.14 3.51 0.42 0.14 5.19 0.14 10.1 0 14.86-1.26-0.42-2.52-0.98-3.93-1.4 0.28-4.48 0.42-8.97 0.42-13.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "m1156.2-1126.8c1.4 0.42 2.66 0.98 3.93 1.4-0.28 4.63-0.7 8.97-1.54 12.9-1.4-0.56-2.8-1.12-4.21-1.68 0.98-4.06 1.54-8.27 1.82-12.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m1158.2-1172.5c0.42 0 0.98-0.14 1.4-0.14 0.42 5.33 0.84 10.8 1.26 16.26-0.56 0-0.98 0.14-1.54 0.14-0.28-5.33-0.7-10.8-1.12-16.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "m1159.3-1156.2c0.56 0 0.98-0.14 1.54-0.14 0.42 5.47 0.84 11.08 0.98 16.4-0.56-0.14-1.12-0.14-1.68-0.28-0.14-5.18-0.42-10.51-0.84-15.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m1160.3-1140.2c0.56 0.14 1.12 0.14 1.68 0.28 0.28 5.33 0.28 10.52 0.14 15.28-0.7-0.28-1.26-0.42-1.82-0.7 0.14-4.62 0.14-9.67 0-14.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m1160.2-1125.4c0.7 0.28 1.26 0.42 1.82 0.7-0.14 4.77-0.56 9.25-1.4 13.04-0.7-0.28-1.4-0.56-1.96-0.84 0.84-3.93 1.4-8.28 1.54-12.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m1159.7-1172.6c2.1-0.28 4.21-0.56 6.59-0.7 0.42 4.91 0.84 10.38 1.4 16.26-2.24 0-4.49 0.7-6.73 0.7-0.56-5.47-0.98-10.94-1.26-16.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "m1160.8-1156.4c2.1 0 4.49-0.7 6.73-0.7 0.56 5.89 0.98 12.06 1.4 17.95-2.38-0.42-4.63-0.42-7.01-0.84-0.27-5.33-0.69-10.94-1.12-16.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m1162-1140c2.38 0.42 4.63 0.42 7.01 0.84 0.28 6.03 0.56 11.92 0.42 17.25-2.38-0.84-4.77-1.82-7.29-2.8 0.14-4.77 0.14-9.96-0.14-15.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m1162.1-1124.7c2.52 0.98 4.91 1.82 7.29 2.8-0.14 5.33-0.42 10.1-1.26 13.74-2.38-1.12-4.77-2.24-7.43-3.51 0.84-3.78 1.26-8.27 1.4-13.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m1166.2-1173.3c8.41-0.84 17.81-1.4 25.24-1.96 0.28 3.65 0.98 9.95 1.54 17.53-7.15 0.42-16.26 0.84-25.38 0.56-0.42-5.75-0.98-11.36-1.4-16.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "m1167.6-1157c9.11 0.28 18.23-0.28 25.38-0.56 0.7 7.71 1.4 16.69 1.96 25.8-6.59-2.1-15-4.35-25.94-7.15-0.41-6.17-0.83-12.34-1.4-18.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m1169-1139.1c10.94 2.66 19.35 4.91 25.94 7.15 0.56 8.97 0.98 18.09 0.98 25.8-6.03-5.19-13.88-10.66-26.5-15.7 0.14-5.34-0.14-11.23-0.42-17.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m1169.4-1121.9c12.62 5.19 20.47 10.52 26.5 15.7 0 7.71-0.28 14.16-1.26 17.81-5.61-6.59-13.04-13.6-26.5-19.77 0.84-3.78 1.12-8.55 1.26-13.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m1191.4-1175.3c7.43-0.42 13.04-0.7 13.88-0.84 0.28 2.38 0.98 9.25 1.82 18.37-1.68-0.7-7.01-0.42-14.16 0-0.56-7.57-1.26-13.88-1.54-17.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "m1193-1157.8c7.15-0.42 12.48-0.7 14.16 0 0.84 9.25 1.96 20.75 2.8 32.53-3.65-2.52-8.41-4.63-15-6.73-0.56-9.12-1.26-18.09-1.96-25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m1194.9-1132c6.59 2.1 11.36 4.21 15 6.73 0.84 11.78 1.54 23.56 1.82 33.51-5.61-4.21-9.81-9.25-15.98-14.44 0.14-7.72-0.28-16.83-0.84-25.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "m1195.9-1106.2c6.03 5.19 10.38 10.09 15.98 14.44 0.28 9.81 0 17.67-1.12 21.45-6.45-5.05-10.38-11.36-16.12-17.95 0.98-3.77 1.26-10.22 1.26-17.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m1205.3-1176.1c2.38-0.28 5.75-0.7 9.81-0.98 0.28 3.93 1.12 12.2 2.24 22.57-4.07-1.82-7.71-3.08-10.1-3.22-0.97-9.12-1.67-15.99-1.95-18.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1207.1-1157.8c2.52 0.14 6.03 1.4 10.1 3.22 0.98 10.38 2.24 22.99 3.22 35.61-4.07-2.94-7.71-5.19-10.52-6.45-0.83-11.63-1.81-23.13-2.8-32.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1215.1-1177.1c4.07-0.42 8.83-0.84 13.74-1.26 0.42 7.57 1.26 18.09 2.1 30.29-4.77-2.24-9.53-4.63-13.6-6.45-0.98-10.38-1.96-18.66-2.24-22.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m1217.4-1154.5c4.07 1.82 8.83 4.07 13.6 6.45 0.84 12.06 1.68 25.66 2.38 39.12-4.35-3.51-8.69-7.01-12.76-9.81-0.98-12.76-2.24-25.38-3.22-35.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "m1210.1-1125.2c2.8 1.12 6.59 3.51 10.52 6.45 0.98 12.62 1.82 25.38 2.1 36.17-3.79-3.79-7.57-6.87-10.8-9.11-0.28-9.96-0.98-21.88-1.82-33.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "m1211.9-1091.7c3.22 2.24 7.01 5.47 10.8 9.11 0.28 10.8 0 19.49-1.26 24.12-3.65-5.05-7.29-9.25-10.66-11.92 1.12-3.65 1.26-11.5 1.12-21.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "m1220.6-1118.8c4.07 2.94 8.41 6.31 12.76 9.81 0.7 13.46 0.98 26.92 0.84 38.56-3.79-4.35-7.71-8.55-11.64-12.2-0.13-10.8-0.97-23.56-1.96-36.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "m1222.7-1082.6c3.79 3.79 7.85 7.99 11.64 12.2-0.14 11.78-0.84 21.73-2.24 28.6-3.36-5.89-6.87-11.64-10.52-16.69 1.12-4.62 1.4-13.45 1.12-24.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "m1229-1178.4c4.91-0.42 10.1-0.98 15-1.54 0.56 11.08 1.12 24.12 1.54 38-4.63-1.68-9.53-3.93-14.44-6.17-0.98-12.21-1.68-22.72-2.1-30.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "m1231-1148.1c4.77 2.24 9.81 4.49 14.44 6.17 0.42 13.88 0.56 28.46 0.56 42.9-3.93-2.94-8.27-6.45-12.62-9.95-0.7-13.46-1.54-27.06-2.38-39.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "m1243.9-1179.9c4.91-0.56 9.53-1.12 13.46-1.82 0.56 12.76 0.7 27.2 0.42 42.48-3.51 0.14-7.85-0.98-12.48-2.66-0.28-13.88-0.84-26.78-1.4-38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "m1245.4-1141.9c4.63 1.68 8.97 2.8 12.48 2.66-0.28 15.28-0.98 31.13-1.96 46.83-2.52-1.26-6.03-3.65-9.95-6.59-0.01-14.44-0.15-29.02-0.57-42.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "m1233.3-1109c4.35 3.51 8.69 7.01 12.62 9.95-0.14 14.44-0.42 28.46-1.26 41.22-3.08-3.93-6.59-8.27-10.38-12.62 0-11.77-0.42-25.09-0.98-38.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "m1234.2-1070.4c3.79 4.35 7.29 8.69 10.38 12.62-0.84 12.76-2.1 24.12-3.79 33.09-2.52-5.33-5.61-11.22-8.83-17.11 1.54-6.87 2.1-16.82 2.24-28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "m1246-1099c3.93 2.94 7.29 5.33 9.95 6.59-0.98 15.56-2.38 30.85-3.93 44.73-1.68-2.66-4.21-6.17-7.29-10.1 0.71-12.76 1.13-26.92 1.27-41.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "m1244.7-1057.8c3.08 3.93 5.61 7.43 7.29 10.1-1.54 13.88-3.36 26.22-5.33 36.17-1.26-3.22-3.22-7.85-5.89-13.18 1.83-8.98 3.09-20.33 3.93-33.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m1076.2-1110.2c10.94-9.25 23.13-12.2 34.63-12.48-2.8 14.02-5.47 24.96-8.41 35.19-13.18 7.15-27.34 17.39-39.12 28.18 4.49-12.19 8.69-27.76 12.9-50.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m1063.3-1059.2c11.78-10.94 25.94-21.17 39.12-28.18-2.94 10.38-6.17 20.05-9.81 31.55-14.72 6.03-30.71 15.7-43.47 28.18 5.19-10.24 9.81-19.22 14.16-31.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "m1110.9-1122.7c11.64-0.28 22.57 2.38 30.99 4.21-1.26 4.77-3.51 12.2-5.89 21.59-8.13-1.68-20.47 2.38-33.65 9.39 3.08-10.23 5.75-21.17 8.55-35.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "m1102.4-1087.4c13.18-7.15 25.52-11.08 33.65-9.39-2.38 9.39-5.05 20.75-7.29 33.65-7.85-1.4-21.31 1.26-36.03 7.29 3.5-11.5 6.72-21.31 9.67-31.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "m1141.9-1118.4c4.35 0.98 11.08 3.37 16.83 5.89-1.68 4.63-3.93 11.78-6.59 20.89-6.03-2.38-12.2-4.49-15.98-5.19 2.23-9.4 4.33-16.83 5.74-21.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "m1136-1096.8c3.79 0.7 10.1 2.8 15.98 5.19-2.52 9.11-5.33 20.33-7.99 32.81-6.31-2.38-12.06-3.93-15.42-4.49 2.38-12.76 5.04-24.12 7.43-33.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "m1158.6-1112.5c1.26 0.56 2.66 1.12 3.79 1.68-1.54 4.63-3.79 11.78-6.31 21.03-1.4-0.56-2.66-1.26-4.07-1.82 2.67-9.12 5.05-16.27 6.59-20.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "m1152-1091.6c1.4 0.56 2.8 1.12 4.07 1.82-2.52 9.11-5.19 20.33-7.71 32.81-1.4-0.56-2.94-1.26-4.35-1.82 2.66-12.48 5.47-23.7 7.99-32.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "m1162.5-1110.8c1.96 0.84 3.79 1.82 5.61 2.66-1.68 4.63-3.93 11.78-6.45 20.89-1.82-0.84-3.65-1.68-5.61-2.52 2.52-9.25 4.76-16.41 6.45-21.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "m1156.2-1089.8c1.82 0.84 3.79 1.68 5.61 2.52-2.52 9.11-5.19 20.19-7.71 32.53-1.82-0.7-3.65-1.54-5.47-2.24 2.38-12.62 5.04-23.7 7.57-32.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "m1168.2-1108.1c18.09 8.41 25.24 18.09 31.97 26.5-1.4 3.36-3.22 8.97-5.05 16.68-8.41-8.13-18.23-15.7-33.37-22.29 2.52-9.25 4.76-16.26 6.45-20.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "m1161.7-1087.4c15.14 6.73 24.96 14.3 33.37 22.29-1.96 7.57-4.07 17.11-6.31 27.9-10.1-7.71-22.71-12.76-34.77-17.67 2.52-12.33 5.32-23.4 7.71-32.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "m1200.1-1081.6c3.22 4.07 6.45 7.99 10.66 11.22-2.1 7.29-4.49 23.98-8.13 45.99-4.49-2.8-8.41-8.41-13.88-12.62 4.62-21.73 8.41-38 11.35-44.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "m1210.8-1070.4c-0.98 3.65-2.1 9.53-3.51 17.39 3.22 2.24 6.73 6.59 10.24 12.06 1.54-7.29 2.8-13.18 3.93-17.53-3.65-5.05-7.3-9.26-10.66-11.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "m1221.4-1058.5c-1.12 4.35-2.52 10.24-3.93 17.53 3.51 5.33 6.87 11.78 10.1 18.23 1.54-6.73 2.94-13.18 4.35-19.07-3.37-5.9-6.88-11.65-10.52-16.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "m1207.3-1052.9c-1.26 7.85-2.8 17.53-4.63 28.6 3.08 1.96 6.59 5.33 10.1 9.39 1.68-9.95 3.22-18.65 4.77-25.94-3.51-5.46-7.01-9.8-10.24-12.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "m1217.5-1041c-1.54 7.29-3.08 15.98-4.77 25.94 3.51 4.07 7.15 8.97 10.52 13.74 1.4-7.57 2.8-14.72 4.35-21.59-3.23-6.31-6.74-12.76-10.1-18.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "m1231.9-1041.8c-1.26 5.89-2.8 12.34-4.35 19.07 3.22 6.45 6.31 12.9 8.83 18.51 1.4-6.17 2.8-12.9 4.35-20.47-2.52-5.33-5.46-11.22-8.83-17.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "m1240.8-1024.7c-1.54 7.57-2.94 14.3-4.35 20.47 2.52 5.47 4.77 10.1 6.31 12.62 1.12-5.33 2.38-11.78 3.93-20.05-1.26-3.23-3.36-7.86-5.89-13.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "m1227.6-1022.7c-1.54 6.73-2.94 14.02-4.35 21.59 3.51 4.91 6.73 9.67 9.53 13.88 0.98-5.19 2.24-10.8 3.65-16.97-2.52-5.6-5.6-12.05-8.83-18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "m1236.4-1004.2c-1.4 6.17-2.66 11.78-3.65 16.97 2.8 4.07 5.33 7.57 7.01 9.53 0.98-4.07 1.82-8.41 2.94-13.74-1.54-2.81-3.64-7.29-6.3-12.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m1049.1-1027.6c-10.52 21.03-33.79 64.64-50.62 90.3 14.58-15.98 42.76-36.03 68.98-52.02 8.41-16.54 17.39-42.76 25.1-66.46-14.72 6.03-30.7 15.56-43.46 28.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m1092.6-1055.8c14.72-6.03 28.32-8.69 36.03-7.29-2.38 13.18-3.22 23.13-3.36 30.57-7.57-0.98-25.52 3.93-45.01 12.76 4.35-11.78 8.56-24.26 12.34-36.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m1080.4-1019.9c19.49-8.83 37.44-13.74 45.01-12.76-0.14 7.43 0.28 12.48 0.28 16.26-7.29-0.56-31.69 11.08-58.05 27.06 4.07-8.26 8.42-19.06 12.76-30.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "m1128.8-1063.2c3.51 0.56 9.81 2.24 16.54 4.91-1.82 12.9-1.82 22.71-1.4 30.15-7.15-2.52-14.58-4.07-18.51-4.49 0.14-7.44 0.84-17.25 3.37-30.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m1125.2-1032.7c3.93 0.42 11.36 1.96 18.51 4.49 0.42 7.43 1.4 12.62 1.96 16.26-7.57-2.38-15.98-4.07-20.19-4.49 0-3.64-0.42-8.82-0.28-16.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "m1145.3-1058.3c1.12 0.42 2.1 0.84 3.22 1.26-1.68 12.9-1.68 22.57-1.12 30.15-1.12-0.42-2.38-0.84-3.51-1.26-0.55-7.44-0.41-17.25 1.41-30.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "m1143.8-1028.2c1.12 0.42 2.38 0.84 3.51 1.26 0.56 7.43 1.68 12.62 2.24 16.26-1.26-0.42-2.52-0.84-3.79-1.26-0.42-3.64-1.4-8.83-1.96-16.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "m1148.4-1056.9c2.94 1.26 6.03 2.52 9.11 3.65-1.4 12.62-1.26 22.29-0.42 29.58-2.66-0.7-6.03-1.82-9.67-3.22-0.57-7.44-0.57-17.25 0.98-30.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "m1147.4-1026.9c3.65 1.4 7.01 2.52 9.67 3.22 0.7 7.29 2.1 12.48 2.8 15.98-2.1-0.28-5.89-1.54-10.24-2.94-0.54-3.64-1.66-8.83-2.23-16.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m1157.5-1053.3c5.47 2.24 11.08 4.63 16.4 7.29-1.82 12.62-1.54 22.15-0.7 29.44-4.63-2.94-9.95-5.47-16.12-7.01-0.84-7.42-0.98-17.1 0.42-29.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "m1157.1-1023.7c6.17 1.54 11.5 4.07 16.12 7.01 0.84 7.29 2.1 12.48 2.38 16.26-3.93-3.51-8.69-6.45-15.7-7.29-0.84-3.5-2.1-8.55-2.8-15.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "m1173.9-1046c5.33 2.66 10.38 5.61 14.86 9.11-2.24 12.48-2.66 22.57-2.66 30.29-4.21-3.51-8.27-7.01-13.04-9.95-0.7-7.43-0.98-16.97 0.84-29.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m1173.2-1016.6c4.63 2.94 8.83 6.45 13.04 9.95 0 7.85 0.56 13.46 0.14 17.53-3.79-3.51-6.87-7.71-10.94-11.22-0.13-3.92-1.4-8.97-2.24-16.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "m1188.8-1037c5.33 4.21 9.39 9.81 13.88 12.62-1.82 11.36-1.96 20.47-1.54 27.48-5.75-1.68-10.24-5.75-14.86-9.67-0.15-7.86 0.27-17.81 2.52-30.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "m1186.1-1006.6c4.77 3.93 9.11 8.13 14.86 9.67 0.42 7.01 1.12 11.92 0.98 15-7.01-0.56-11.64-3.51-15.7-7.29 0.42-3.92 0-9.66-0.14-17.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "m1202.6-1024.4c-1.82 11.36-1.96 20.47-1.54 27.48 3.08 1.12 6.31 3.22 9.67 6.03 0-6.03 0.28-13.74 1.96-24.12-3.5-4.06-7.01-7.43-10.09-9.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "m1212.7-1015c-1.68 10.24-1.96 18.09-1.96 24.12 3.37 2.8 6.59 6.17 9.81 9.39 0.56-5.61 1.26-11.92 2.66-19.77-3.36-4.77-7-9.53-10.51-13.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "m1201.1-996.93c0.42 7.01 1.12 11.92 0.98 15 3.08 0.28 6.03 2.24 8.69 5.19 0.42-3.65 0-7.99 0-14.16-3.36-2.81-6.58-4.91-9.67-6.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "m1210.8-990.9c0 6.03 0.42 10.52 0 14.16 2.66 2.94 5.33 6.59 7.71 10.52 0.98-4.77 1.54-9.53 2.1-15.14-3.22-3.37-6.59-6.74-9.81-9.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "m1223.2-1001.1c-1.4 7.85-2.1 14.16-2.66 19.77 3.22 3.37 6.31 6.73 8.97 9.53 1.12-5.19 2.1-10.1 3.22-15.56-2.8-4.06-6.03-8.97-9.53-13.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "m1232.8-987.4c-1.12 5.33-2.1 10.38-3.22 15.56 2.8 2.8 5.19 5.19 7.15 6.45 1.12-4.35 2.1-8.27 3.08-12.48-1.68-1.96-4.06-5.32-7.01-9.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "m1220.6-981.37c-0.56 5.61-1.12 10.38-2.1 15.14 2.52 3.79 4.77 7.71 7.15 10.66 1.54-5.89 2.8-11.08 4.07-16.26-2.81-2.81-5.89-6.17-9.12-9.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "m1229.6-971.83c-1.12 5.19-2.38 10.38-4.07 16.26 2.24 3.08 4.49 5.33 6.73 5.89 1.82-6.31 3.22-11.36 4.49-15.7-1.96-1.27-4.35-3.65-7.15-6.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m998.49-937.48c29.16-31.97 112.59-80.2 127.03-78.94 0 2.8-0.56 9.95-1.68 20.05-20.47 5.61-95.06 48.51-124.37 77.12-1.68-9.4-2.1-16.41-0.98-18.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m999.47-919.26c29.3-28.6 103.76-71.51 124.37-77.12-4.21 42.2-15.56 135.86-18.23 179.47-33.23 0-57.63-13.04-74.87-32.67-16.4-19.06-26.36-44.16-31.27-69.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m1125.5-1016.4c4.35 0.42 12.62 2.1 20.19 4.49-1.68 27.34-18.23 139.65-28.6 194.75-4.49 0.28-7.57 0.14-11.5 0.14 3.23-53.98 19.91-184.94 19.91-199.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m1145.7-1011.9c0.84 0.28 1.68 0.56 2.38 0.84-2.1 28.46-18.79 138.81-30.01 193.91h-0.98c10.38-55.11 26.93-167.55 28.61-194.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m1148.2-1011.2c4.91 1.68 9.25 3.08 11.64 3.51-1.4 17.81-6.31 51.46-12.76 87.49-2.38 0-6.87-3.22-10.52-3.93 5.89-38.14 10.51-72.77 11.64-87.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m1136.6-924.16c3.65 0.7 8.13 3.93 10.52 3.93-6.45 36.03-14.3 74.45-22.01 102.21-2.24 0.42-4.63 0.7-6.87 0.84 5.6-27.62 12.47-68.99 18.36-106.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "m1159.7-1007.7c10.66 1.4 16.26 7.43 21.59 13.32-0.7 12.76-2.1 26.64-4.21 40.94-5.89-8.13-12.06-16.4-22.01-17.39 2.39-15.14 3.93-27.89 4.63-36.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m1155.2-970.85c9.95 0.98 15.98 9.25 22.01 17.39-2.1 14.3-4.77 29.16-7.99 44.17-6.87-5.19-13.88-10.8-22.15-10.94 3.08-18.09 6.02-35.48 8.13-50.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m1147.1-920.24c8.27 0.14 15.28 5.75 22.15 10.94-6.59 29.86-15.84 60.01-27.48 86.51-5.33 2.1-10.8 3.79-16.54 4.77 7.57-27.77 15.42-66.18 21.87-102.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "m1181.3-994.41c2.66 2.94 5.33 5.89 8.55 8.13-0.7 15.42-1.82 29.86-3.51 43.75-3.36-2.94-6.31-7.01-9.25-11.08 2.1-14.16 3.5-28.04 4.21-40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1177.3-953.47c2.94 4.07 5.89 7.99 9.25 11.08-1.68 13.88-3.93 27.06-7.01 39.96-3.51-1.68-6.87-4.35-10.24-6.87 3.23-15 5.9-29.87 8-44.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "m1190-986.28c3.22 2.24 7.01 3.93 12.06 4.35-0.7 16.69-1.96 31.27-3.93 44.59-4.63-0.14-8.41-2.1-11.64-5.19 1.69-13.74 2.67-28.18 3.51-43.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "m1186.5-942.39c3.36 2.94 7.15 5.05 11.64 5.19-1.96 13.32-4.49 25.38-8.13 37.02-3.65 0.56-7.15-0.42-10.66-2.24 3.09-12.91 5.47-26.23 7.15-39.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "m1169.1-909.3c6.87 5.19 13.46 10.1 20.89 9.11-7.01 23.13-17.67 44.31-33.37 69.68-4.77 2.94-9.81 5.47-15 7.71 11.63-26.63 20.89-56.78 27.48-86.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "m1202.1-981.93c-1.4 33.23-4.91 58.47-11.92 81.6 3.08-0.84 5.61-1.12 7.85-1.26 7.01-21.45 10.8-44.59 12.9-75.15-2.94-2.95-5.75-4.91-8.83-5.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "m1210.8-976.74c-1.96 30.57-5.75 53.84-12.9 75.15 2.24-0.14 4.07 0 5.89 0 7.01-19.35 11.64-40.1 14.72-64.78-2.38-3.64-5.05-7.43-7.71-10.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "m1190.2-900.33c-7.01 23.13-17.67 44.31-33.37 69.68 3.08-1.82 6.17-4.07 9.25-6.45 14.72-23.41 24.96-43.04 31.97-64.5-2.24 0.15-4.77 0.43-7.85 1.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "m1197.9-901.59c2.24-0.14 4.07 0 5.89 0-3.51 9.67-7.57 19.07-12.34 28.32-2.1 1.12-4.21 2.1-6.73 3.08 5.47-10.37 9.67-20.6 13.18-31.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "m1184.8-870.04c2.38-1.12 4.63-1.96 6.73-3.08-4.77 9.25-10.24 18.65-16.4 28.18-2.94 2.8-6.03 5.47-9.11 7.99 7.28-11.78 13.45-22.58 18.78-33.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "m1218.5-966.23c-3.08 24.68-7.71 45.43-14.72 64.78 1.82 0 3.51 0 5.33-0.42 6.87-16.97 12.2-34.91 16.4-53.56-2.24-3.22-4.49-7.01-7.01-10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "m1225.6-955.57c2.24 3.08 4.49 5.33 6.73 5.89-2.38 7.99-4.91 15.7-7.71 23.27-2.24 0-4.35-0.56-6.17-1.68 2.66-8.97 5.05-18.09 7.15-27.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "m1218.3-928.09c1.96 0.98 3.93 1.68 6.17 1.68-2.8 7.57-5.89 14.86-9.11 21.87-2.38 1.4-4.35 2.24-6.31 2.66 3.5-8.54 6.59-17.24 9.25-26.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "m1203.9-901.45c3.65 0 6.87-0.14 11.64-3.08-3.37 7.15-6.87 14.02-10.8 20.75-4.91 5.61-8.83 8.41-13.04 10.66 4.63-9.4 8.69-18.65 12.2-28.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "m1191.6-873.13c4.21-2.24 8.13-5.05 13.04-10.66-3.93 6.73-8.13 13.32-12.76 19.77-5.05 6.87-10.8 13.46-16.83 19.07 6.32-9.53 11.78-18.92 16.55-28.18z"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -1275.4,
    x2: -1272.5,
    y1: 924.93,
    y2: 924.93,
    gradientTransform: "matrix(6.8309 5.3014 5.3014 -6.8309 4034.2 13321)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBCC93",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68B1B",
    offset: 1
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "m231.46 242.7c-8.69 8.55-16.68 12.9-21.03 15.56-1.82 1.26-2.66 2.1-2.66 4.35 0 0.56 0.14 0.84 0.56 0.84 0.84 0 2.1-1.26 4.63-1.26 6.45 0 13.18 7.43 21.03 7.43 9.53 0 24.12-11.5 27.76-14.16l0.56 0.84c-5.47 6.03-26.22 22.71-34.21 22.71-4.63 0-7.15-1.26-7.15-2.66 0-2.1 3.37-4.63 5.19-6.03-0.14-0.14-1.26-0.56-1.68-0.84-1.4 0.98-6.73 4.63-6.73 7.85 0 3.93 5.19 5.19 9.95 5.19 4.21 0 8.27-2.24 10.66-3.51 5.61-3.37 19.63-13.6 24.12-17.53 4.21-3.51 5.61-6.73 5.61-10.66 0-5.19-9.39-6.73-10.24-19.35-0.42-8.27-1.26-10.8-2.24-10.8-2.1 0-3.93 5.19-10.24 5.19-4.63 0-3.51-6.31-4.63-6.31-1.83 0.58-1.83 15.86-9.26 23.15"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "m275.49 224.89c-2.52 0-3.37-1.82-3.37-4.07 0-3.08 1.12-6.03 3.37-6.03 1.82 0 3.08 2.52 3.22 6.17 0 2.53-1.4 3.93-3.22 3.93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAflacIcon);
export default __webpack_public_path__ + "static/media/aflac-icon.b0c98311038afe4ce071400c6c84de08.svg";
export { ForwardRef as ReactComponent };